export const PRODUCTS_RESET_STATE = 'PRODUCTS_RESET_STATE';
export const PRODUCTS_CURRENT_ITEM = 'PRODUCTS_CURRENT_ITEM';

export const PRODUCTS_REQUEST_LOADING = 'PRODUCTS_REQUEST_LOADING';
export const PRODUCTS_REQUEST_SUCCESS = 'PRODUCTS_REQUEST_SUCCESS';
export const PRODUCTS_REQUEST_FAILED = 'PRODUCTS_REQUEST_FAILED';

export const PRODUCTS_CURRENT_ACTION = 'PRODUCTS_CURRENT_ACTION';
export const PRODUCTS_RESET_ACTION = 'PRODUCTS_RESET_ACTION';